"use client";
export const Currency = ({
  amount,
  currency = "EUR",
  denominator = 2,
}: {
  amount?: number;
  currency?: string;
  denominator?: number;
}) => {
  const denominatedAmount = amount ? amount / Math.pow(10, denominator) : 0;
  return (
    <>
      {denominatedAmount.toLocaleString("de-DE", {
        style: "currency",
        currency,
      })}
    </>
  );
};

export const CurrencyLight = ({
  amount,
  currency = "EUR",
  denominator = 2,
}: {
  amount?: number;
  currency?: string;
  denominator?: number;
}) => {
  const denominatedAmount = amount ? amount / Math.pow(10, denominator) : 0;
  return (
    <>
      {denominatedAmount.toLocaleString("de-DE", {
        style: "decimal",
      })}
    </>
  );
};

export const CurrencyWithTax = ({
  amount,
  currency = "EUR",
  taxRate = 0,
  denominator = 2,
}: {
  amount?: number;
  currency?: string;
  taxRate?: number;
  denominator?: number;
}) => {
  const normalizedTaxRate = (taxRate / 100) + 1;
  const totalAmount = amount ? amount * normalizedTaxRate : 0;

  return (
    <>
      <Currency amount={totalAmount} currency={currency} denominator={denominator} />
    </>
  );
}

export const CurrencyWithTaxLight = ({
  amount,
  currency = "EUR",
  taxRate = 0,
  denominator = 2,
}: {
  amount?: number;
  currency?: string;
  taxRate?: number;
  denominator?: number;
}) => {
  const normalizedTaxRate = (taxRate / 100) + 1;
  const totalAmount = amount ? amount * normalizedTaxRate : 0;

  return (
    <>
      <CurrencyLight amount={totalAmount} currency={currency} denominator={denominator} />
    </>
  );
}

export const getCurrencyString = ({
  amount,
  currency = "EUR",
  denominator = 2,
}: {
  amount?: number;
  currency?: string;
  denominator?: number;
}) => {
  const denominatedAmount = amount ? amount / Math.pow(10, denominator) : 0;
  return denominatedAmount.toLocaleString("de-DE", {
    style: "currency",
    currency,
  });
};
